<template>
  <div>
    <span class="hidden-xs-up">
      {{ data.dateSubmitted | shortDate }}
    </span>
    {{ data.dateSubmitted | shortDate }}
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'DateTag',
  props: {
    data: {
      required: true,
      type: Object
    }
  }
}
</script>
